import { api } from '@/shared/api/http'
import type { PageResult } from '@/shared/api/types'
import type {
  AccountItem,
  AccountPayload,
  AccountStatus,
  PermissionGroup,
  RoleItem,
  RoleOption,
  RolePayload,
} from './types'

export interface AccountQuery {
  page: number
  pageSize: number
  keyword?: string
  roleId?: string
  status?: string
}

export interface RoleQuery {
  page: number
  pageSize: number
  keyword?: string
  status?: string
}

export function getAccounts(query: AccountQuery) {
  return api.get<PageResult<AccountItem>>('/identity/accounts', query)
}

export function createAccount(payload: AccountPayload) {
  return api.post<AccountItem, AccountPayload>('/identity/accounts', payload)
}

export function updateAccount(id: string, payload: AccountPayload) {
  return api.put<AccountItem, AccountPayload>(`/identity/accounts/${id}`, payload)
}

export function deleteAccount(id: string) {
  return api.delete<{ success: boolean }>(`/identity/accounts/${id}`)
}

export function updateAccountStatus(id: string, status: AccountStatus) {
  return api.patch<{ success: boolean }, { status: AccountStatus }>(
    `/identity/accounts/${id}/status`,
    { status },
  )
}

export function resetAccountPassword(id: string, password: string) {
  return api.post<{ success: boolean }, { password: string }>(
    `/identity/accounts/${id}/reset-password`,
    { password },
  )
}

export function changeMyPassword(currentPassword: string, newPassword: string) {
  return api.post<{ success: boolean }, { currentPassword: string; newPassword: string }>(
    '/identity/me/change-password',
    { currentPassword, newPassword },
  )
}

export function getRoles(query: RoleQuery) {
  return api.get<PageResult<RoleItem>>('/identity/roles', query)
}

export function getRoleOptions() {
  return api.get<RoleOption[]>('/identity/role-options')
}

export function createRole(payload: RolePayload) {
  return api.post<RoleItem, RolePayload>('/identity/roles', payload)
}

export function updateRole(id: string, payload: RolePayload) {
  return api.put<RoleItem, RolePayload>(`/identity/roles/${id}`, payload)
}

export function deleteRole(id: string) {
  return api.delete<{ success: boolean }>(`/identity/roles/${id}`)
}

export function getPermissionCatalog() {
  return api.get<PermissionGroup[]>('/identity/permissions')
}
